import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { route } from 'preact-router';
import linkState from 'linkstate';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';

@observer
class Logo extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    scrollToTop = () => {
		const {  refreshPage = () => {}, clickOnLogo = () => {} } = this.props;
		const { appState } = this.props.stores;
		appState.appContainerScrollTop();
		refreshPage();
        clickOnLogo();
	}

    loadAll = async (props = this.props) => {
        const { appState, customerStore } = this.props.stores;
        const { customer } = customerStore;
        const { customerid } = props;
        if (customerid && customerid !== customer.id) {
            await customerStore.loadPublic(parseInt(customerid, 10));
        }
    }

    componentDidMount() {
        this.loadAll();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.customerid !== this.props.customerid) {
            this.loadAll(nextProps);
        }
    }

    render() {
        const { customerid, logoHeight = '45px' } = this.props;
        const { appState, raceStore, userStore, customerStore } = this.props.stores;

        const { customerPublic } = customerStore;
        const { currentCustomer } = appState;
        const { user } = userStore;
        const darkmode = util.getNestedValue(user, 'settings.darkmode');
        const invertStyle = darkmode && currentCustomer.logoInvert ? ' filter: invert(1);' : '';

        // Parse logoHeight to get numeric value for mobile scaling
        const heightNum = parseInt(logoHeight, 10) || 45;
        const mobileHeight = Math.min(heightNum, 35); // Cap at 35px on mobile

        return (<>
            <a
                href={`/`}
                onClick={this.scrollToTop}
            >
                {currentCustomer.images && currentCustomer.images.length > 0 ? <>
                    <img
                        src={localUtil.displayImg(currentCustomer.images[0], this.props, '400x')}
                        class='logoImg img-fluid d-none d-sm-inline'
                        style={`max-height: ${logoHeight};${invertStyle}`}
                    />
                    <img
                        src={localUtil.displayImg(currentCustomer.images[0], this.props, '400x')}
                        class='logoImg img-fluid d-inline d-sm-none'
                        style={`max-height: ${mobileHeight}px;${invertStyle}`}
                    />
                </> : <></>}
            </a>
        </>);
    }
}

export default Logo;
